(function () {

    'use strict';
    angular.module('app').controller('createCompanyController', ['$scope', '$uibModalInstance', '$location', '$routeParams', 'companyService','accountsService', createCompanyController]);

    function createCompanyController($scope, $uibModalInstance, $location, $routeParams, companyService, accountsService) {

     
        $scope.model = {};
        $scope.model.loading = true;
        $scope.model.working = false;
        $scope.model.success = false;

        $scope.createCompany = {};
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
        $scope.navigateToCompany = function() {
            $location.url('/company/' + $scope.model.companyId);
            $scope.cancel();
        }
        $scope.submit = function () {
            $scope.model.submitted = true;
            if (!$scope.createCompany.$valid) {
                return;
            }

            $scope.model.working = true;


            var company = {
                Name: $scope.model.companyName,
                PartnerCode: $scope.model.partnerCode,
                EmailDomain: $scope.model.emailDomain,
                Address1: $scope.model.address1,
                Address2: $scope.model.address2,
                Address3: $scope.model.address3,
                PostCode: $scope.model.postCode,
                IsCrmIntegrated: $scope.model.isCrmIntegrated,
                CrmName: $scope.model.crmName
            };

       

            $scope.model.complete = false;

            companyService.createCompany(company).then(function (response) {
                    $scope.model.working = false;

                    $scope.model.complete = true;
                    $scope.model.success = true;

                    $scope.model.companyId = response.id;


                },
                function (response) {
                    $scope.model.working = false;

                    $scope.model.error = response;
                    $scope.model.complete = true;
                    $scope.model.success = false;
                });
        }
        $scope.getAuthenticatedAccount = function () {

            accountsService.getAuthenticatedAccount().then(function(response) {

                $scope.model.isAdmin = (response.accountType === AccountType.Admin || response.accountType === AccountType.SuperAdmin);
                $scope.model.isPartnerAdmin = response.accountType === AccountType.Partner || response.accountType === AccountType.PartnerSuperAdmin;
                $scope.model.isPartnerSuperAdmin = response.accountType === AccountType.PartnerSuperAdmin;
                $scope.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);
                $scope.model.isCompanyAdmin = response.accountType === AccountType.Company;
                $scope.model.authenticatedAccountId = response.accountId;

                if ($scope.model.isPartnerAdmin)
                    $scope.model.partnerCode = response.partnerCode;

                $scope.model.loading = false;
            });
        }
        $scope.getAuthenticatedAccount();
    }
})();